import { NgModule } from '@angular/core';

import { MgOdometerElement } from './MgOdometer.element';

@NgModule({
  declarations: [MgOdometerElement],
  exports: [MgOdometerElement],
})
export class MgOdometerModule {}
